// CONFIGURATION

export { loadExampleFile } from './local-loader';

// LOCALHOST
// export var WS_BASE_ADDRESS = 'ws://localhost:8080/api/';

// DEPLOYED
export var WS_BASE_ADDRESS = 'ws://tessla-a.isp.uni-luebeck.de/api/';



//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 538
// module chunks = 0